(function($) {
	var $sideBySidedataBlocks =
		$('.datablock.block-size-6 .data-block');

	$('.datablock.block-size-6').first().addClass('first');

	if ($sideBySidedataBlocks.length === 0 || $(window).width() < 767) {
		return;
    }

    var dataBlockHeights = $sideBySidedataBlocks.map(function (i, element) {
		return Math.ceil($(element).outerHeight());
	});

	var highestBlockHeight = Math.max.apply(null, dataBlockHeights);

	$sideBySidedataBlocks.each(function(i, element) {
		var $dataBlock = $(element);
		if (highestBlockHeight > $dataBlock.outerHeight()) {
			$dataBlock.css('height', highestBlockHeight);
			$dataBlock.addClass('data-block--adjusted-height');
		}
	});
})(jQuery);
